/**
 * 日本語レベルの列挙クラス
 * @param code : コード
 * @param level : 日本語レベル
 */
const _langLevels = [
  { "code": 1, "level": 'N1'},
  { "code": 2, "level": 'N2'},
  { "code": 3, "level": 'N3'},
  { "code": 4, "level": 'N4'},
  { "code": 5, "level": 'N5'},
  { "code": 9, "level": '不問(NONE)'},
]

export default {
  data () {
    return {
      langLevels: _langLevels,
    }
  }
}

